
import React from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useNavigate } from "react-router-dom";

export function AuthenticationRequired() {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex flex-col items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardContent className="flex flex-col items-center p-6">
          <h1 className="text-xl font-bold mb-4">Authentication Required</h1>
          <p className="text-center mb-6">You need to be logged in to access sermon plans.</p>
          <Button onClick={() => navigate("/premium")}>
            Sign In or Sign Up
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
